module.exports = __webpack_public_path__ + "img/5.dcad5e24.png";